var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteLogo1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 28,
    viewBox: "0 0 126 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_740_594958)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_740_594958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07927 21.3668L13.6526 6.82998H12.8014L7.70434 20.309H7.65368L2.55664 6.82998H1.69531L7.26861 21.3668H8.07927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1928 21.3668H15.9832V10.5171H15.1928V21.3668ZM15.588 7.85752C15.9427 7.85752 16.2264 7.58553 16.2264 7.24301C16.2264 6.89042 15.9427 6.61842 15.588 6.61842C15.2435 6.61842 14.9598 6.89042 14.9598 7.24301C14.9598 7.58553 15.2435 7.85752 15.588 7.85752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6104 21.5078C24.637 21.5078 26.2178 20.1982 26.7245 18.4453H26.7549V21.3668H27.4946V6.19531H26.7042V13.3781H26.684C26.1976 11.6856 24.6168 10.376 22.6003 10.376C19.8744 10.376 17.9491 12.6326 17.9491 15.947C17.9491 19.2512 19.8845 21.5078 22.6104 21.5078ZM22.7016 11.0913C25.0424 11.0913 26.7144 13.0759 26.7144 15.947C26.7144 18.808 25.0424 20.8026 22.7016 20.8026C20.3709 20.8026 18.7496 18.8382 18.7496 15.9369C18.7496 13.0456 20.3709 11.0913 22.7016 11.0913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2332 11.0812C36.5335 11.0812 38.094 12.8341 38.1042 15.403H30.2711C30.3927 12.8139 31.9634 11.0812 34.2332 11.0812ZM37.9724 18.3345C37.6583 19.7549 36.3308 20.8026 34.3346 20.8026C31.8823 20.8026 30.261 19.0699 30.261 16.1081V16.0678H38.9047V15.6145C38.9047 12.4613 37.0604 10.376 34.2434 10.376C31.3655 10.376 29.4605 12.5923 29.4605 15.957C29.4605 19.4426 31.3655 21.5078 34.3244 21.5078C36.7362 21.5078 38.4183 20.168 38.773 18.3345H37.9724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0759 21.5078C47.9841 21.5078 49.9398 19.352 49.9398 15.947C49.9398 12.5319 47.9841 10.376 45.0759 10.376C42.1777 10.376 40.222 12.5319 40.222 15.947C40.222 19.352 42.1676 21.5078 45.0759 21.5078ZM45.0759 20.8026C42.6236 20.8026 41.0124 18.9389 41.0124 15.947C41.0124 12.9449 42.6236 11.0913 45.0759 11.0913C47.5281 11.0913 49.1393 12.9449 49.1393 15.947C49.1393 18.9289 47.5281 20.8026 45.0759 20.8026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8325 8.32093H63.8832L67.7744 21.3668H68.4837L72.5674 6.82998H71.7264L68.129 19.9866H68.0784L64.2277 6.82998H63.4779L59.6374 19.9866H59.5867L55.9793 6.82998H55.1483L59.232 21.3668H59.9414L63.8325 8.32093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3103 21.3668H75.1007V10.5171H74.3103V21.3668ZM74.7055 7.85752C75.0602 7.85752 75.3439 7.58553 75.3439 7.24301C75.3439 6.89042 75.0602 6.61842 74.7055 6.61842C74.361 6.61842 74.0773 6.89042 74.0773 7.24301C74.0773 7.58553 74.361 7.85752 74.7055 7.85752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6138 21.3668H78.4042V14.9093C78.4042 12.6528 79.8431 11.0913 81.9812 11.0913C84.018 11.0913 85.3556 12.3505 85.3556 14.456V21.3668H86.146V14.3653C86.146 11.9274 84.5551 10.376 82.1535 10.376C80.2991 10.376 78.8906 11.3834 78.3839 12.9046H78.3535V10.5171H77.6138V21.3668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.611 21.5078C94.6377 21.5078 96.2185 20.1982 96.7251 18.4453H96.7555V21.3668H97.4953V6.19531H96.7049V13.3781H96.6846C96.1982 11.6856 94.6174 10.376 92.6009 10.376C89.875 10.376 87.9497 12.6326 87.9497 15.947C87.9497 19.2512 89.8852 21.5078 92.611 21.5078ZM92.7022 11.0913C95.043 11.0913 96.715 13.0759 96.715 15.947C96.715 18.808 95.043 20.8026 92.7022 20.8026C90.3716 20.8026 88.7503 18.8382 88.7503 15.9369C88.7503 13.0456 90.3716 11.0913 92.7022 11.0913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.315 21.5078C107.223 21.5078 109.179 19.352 109.179 15.947C109.179 12.5319 107.223 10.376 104.315 10.376C101.417 10.376 99.4611 12.5319 99.4611 15.947C99.4611 19.352 101.407 21.5078 104.315 21.5078ZM104.315 20.8026C101.863 20.8026 100.252 18.9389 100.252 15.947C100.252 12.9449 101.863 11.0913 104.315 11.0913C106.767 11.0913 108.378 12.9449 108.378 15.947C108.378 18.9289 106.767 20.8026 104.315 20.8026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.257 10.5171H123.426L120.619 20.4903H120.589L117.539 10.5171H116.647L113.597 20.4903H113.567L110.76 10.5171H109.929L113.111 21.3668H114.033L117.083 11.5345H117.103L120.153 21.3668H121.075L124.257 10.5171Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_740_594958",
    x: -18.3047,
    y: -9.80469,
    width: 162.562,
    height: 55.3125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_594958"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_740_594958",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_740_594958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo1);
export default __webpack_public_path__ + "static/media/white-logo1.8c7b7c9b47a9f6fe414603a11d57ec9e.svg";
export { ForwardRef as ReactComponent };